/**<params>说明
 * height 高度：number ｜ xs:30  sm:60  md:90  lg:120  xl:150  xxl:180
 * background 颜色：string
 */

import css from './index.module.scss';

export default function LineSpace({ height = 30, background = '#000', border = 'none', opacity = 1 }: any) {
    const arr: any = {
        xs: 30,
        sm: 60,
        md: 90,
        lg: 120,
        xl: 150,
        xxl: 180,
    };
    if (typeof height === 'string') {
        height = arr[height];
    }
    return (
        <div
            className={css.lineSpace}
            style={{
                height: height + 'px',
                background: background,
                border: border,
                opacity: opacity,
            }}
        ></div>
    );
}
